import React from 'react';
import { Dimmer, Loader, Image, Segment } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

const LoaderExampleTextShorthand = () => (
  <div class="ui active centered inline loader"></div>
);

export default LoaderExampleTextShorthand;
